import React, { Fragment } from 'react';
import { shape, string, object } from 'prop-types';
import Helmet from 'react-helmet';
import { Link } from 'react-router-dom';
import { Segment, Button, Tab } from 'semantic-ui-react';

import Heading from '~/views/common/Heading';
import Section from '~/views/common/Section';
import DataTable from '~/views/common/DataTable';
import BoolIcon from '~/views/common/BoolIcon';

import Login from './Login';
import FeatureFlags from './FeatureFlags';
import { UserTabGeneral } from './UserTabGeneral';
import { UserTabEmailLogs } from './UserTabEmailLogs.jsx';

// Add tabs to the user View table Page here

const UserView = ({
    data: {
        id,
        name,
        logo,
    },
    data,
    ssoData,
}) => (
    <Fragment>
        <Helmet title={name} />

        <Heading
            imageSrc={logo}
            header={name}
            subheader="User"
        >
            <Button
                as={Link}
                to={`/users/${id}/edit`}
                color="blue"
                icon="pencil"
                content="Edit"
                labelPosition="right"
            />
        </Heading>
        <Tab panes={[
            {
                menuItem: 'General',
                render: () => <UserTabGeneral data={data} ssoData={ssoData} />,
            },
            {
                menuItem: 'Email Logs',
                render: () => <UserTabEmailLogs userId={id} />,
            },
        ]}
        />

    </Fragment>
);

UserView.propTypes = {
    data: shape({
        id: string.isRequired,
        name: string.isRequired,
        logo: string.isRequired,
    }).isRequired,
    ssoData: object,
};

export default UserView;
